import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "redux/actions/Index";
import LiveopsPage from "components/pages/liveops/LiveopsPage";
import { ILiveOpsPageState } from "interfaces/liveops.interface";
import { RootState } from "redux/reducers/RootReducer";

export const mapStateToProps = (state: RootState, props: any): any => {
  const { liveops } = state;
  return {
    isLoading: liveops.isLoading,
    isError: liveops.isError,
    error: liveops.error,
    deliveryDateUpdated: liveops.deliveryDateUpdated,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateDeliveryDate: (payload: FormData) =>
      dispatch(actions.updateDeliveryDateInLiveops(payload)),
  };
};

const LiveopsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveopsPage);
export default LiveopsContainer;
